import { CHAT_LIST_PAGE_SIZE } from "@/config/constants";
import { useInfiniteQuery } from "@tanstack/react-query";
import { searchPublicGroupChats } from "../chats";

interface UsePaginatedPublicChatOptions {
  searchTerm: string;
  count?: number; // Results per page
}

export function usePaginatedPublicGroupChats({
  count = CHAT_LIST_PAGE_SIZE,
  searchTerm,
}: UsePaginatedPublicChatOptions) {
  // Set up the infinite query
  const {
    data,
    status,
    error,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["search-public-groups", searchTerm],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await searchPublicGroupChats(
        searchTerm,
        pageParam,
        count,
      );
      return response;
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < count) {
        return undefined;
      }
      return allPages.length * count;
    },
    initialPageParam: 0, // initial offset skip
    // Only enable the query if there is a search term.
    enabled: !!searchTerm,
    // TO DO => To be configured later based on estimated usage and best performance
    // staleTime: 60000,
    // gcTime: 1000, // Inactive queries are garbage collected after 5 minutes by default.
    // refetchInterval: 10000,
    // refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });

  return {
    data,
    status,
    isFetching,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    error,
    refetch,
  };
}
